import { Col, Row, Modal, Form, Switch, message } from "antd";
import Title from "../../UI/Title/Title";
import { useTranslation } from "react-i18next";
import { useState, useEffect, Dispatch } from "react";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { CurrencyType } from "./currencyType";
import { createCurrency, editCurrency } from "../../../api/currency";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";
import { AxiosResponse } from "axios";
import InputName from "../../UI/InputNumberComponent/InputName";
type propsType = {
  id?: string | number;
  openCurrency: boolean;
  Currency?: CurrencyType | undefined;
  setOpenCurrency: React.Dispatch<React.SetStateAction<boolean>>;
  filter: boolean | undefined;
  search: any;
  page: number;
  CurrencyMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  setPaginatedCurrency: Dispatch<any>;
};
export const AddEditCurrency = ({
  openCurrency,
  setOpenCurrency,
  Currency,
  id,
  search,
  filter,
  page,
  CurrencyMutation,
  setPaginatedCurrency,
}: propsType) => {
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [, setError] = useState("");
  const [isActive, setIsActive] = useState<boolean>(
    Currency ? Currency?.isActive : true
  );
  const isEdit = () => {
    return !!id && id !== undefined && id !== "";
  };

  const onError = (error: any, variables: CurrencyType, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createpaymentModes" : "editpaymentModes",
    !isEdit()
      ? (currency: CurrencyType) => createCurrency(currency)
      : (currency: CurrencyType) => editCurrency(id, currency),
    {
      onSuccess: (res) => {
        setOpen(false);
        setOpenCurrency(false);
        message.success("Complete successfully");
        CurrencyMutation({
          q: search,
          isActive: filter,
          limit: page * 8 + 8,
        }).then((res: any) => {
          setPaginatedCurrency(res.data);
        });
      },
      onError,
    }
  );
  const handleFinish = () => {
    const newCurrency = form.getFieldsValue();
    for (const key in newCurrency) {
      if (newCurrency[key] === undefined) {
        if (key === "isActive") {
          newCurrency[key] = true;
        } else {
          newCurrency[key] = null;
        }
      } else if (
        typeof newCurrency[key] === "string" &&
        newCurrency[key].trim() === ""
      ) {
        newCurrency[key] = null;
      }
    }
    mutateCreateUpdate(newCurrency);
  };
  const [InputValue, setInputValue] = useState(false);
  const [SymbolValue, setSymbolValue] = useState(false);
  const [Abbreviation, setAbbreviation] = useState(false);

  const handleInputChange = (event: any) => {
    setInputValue(event);
  };
  const handleInputSymbal = (value: any) => {
    setSymbolValue(value);
  };

  const handleInputAbbreviation = (value: any) => {
    setAbbreviation(value);
  };
  const [editStatus] = useState(isEdit());

  useEffect(() => {
    if (editStatus) {
      setInputValue(true);
      setSymbolValue(true);
      setAbbreviation(true);
    }
  }, [editStatus]);
  return (
    <>
      <Modal
        data-testid="modal"
        closable={false}
        maskClosable={false}
        width={490}
        centered
        onCancel={() => setOpenCurrency(false)}
        open={openCurrency}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          disabled: !InputValue || !Abbreviation || !SymbolValue,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={isEdit() ? `${t("save")}` : `${t("add")}`}
        onOk={() => {
          setOpen(true);
        }}
      >
        <Title
          title={isEdit() ? `${t("edit-currency")}` : `${t("add-currency")}`}
        />
        {isEdit() && (
          <span className="modaltitleEdit">
            {t("edit-details-for")} {Currency?.name}
          </span>
        )}
        <Form
          data-testid="form"
          layout="vertical"
          id="CurrencyForm"
          form={form}
          onFinish={handleFinish}
        >
          <Row>
            <Col span={14} style={{ marginTop: "20px" }}>
              <Form.Item
                initialValue={Currency?.name}
                name="name"
                label={t("currency-name")}
                rules={[
                  {
                    required: true,
                    message: "currency name is required",
                  },
                ]}
              >
                <InputName
                  maxLength={50}
                  onChange={handleInputChange}
                  data-testid="currency"
                />
              </Form.Item>
              <Form.Item
                initialValue={Currency?.symbol}
                name="symbol"
                label={t("symbol")}
                rules={[
                  {
                    required: true,
                    message: "symbol is required",
                  },
                ]}
              >
                <InputName
                  maxLength={5}
                  onChange={handleInputSymbal}
                  data-testid="symbol"
                />
              </Form.Item>
              <Form.Item
                initialValue={Currency?.abbreviation}
                name="abbreviation"
                label={t("abbreviation")}
                rules={[
                  {
                    required: true,
                    message: "abbreviation is required",
                  },
                ]}
              >
                <InputName
                  maxLength={10}
                  onChange={handleInputAbbreviation}
                  data-testid="abbreviation"
                />
              </Form.Item>
              <Form.Item name="isActive" label={`${t("status")}`}>
                <Switch
                  checkedChildren={`${t("active")}`}
                  unCheckedChildren={`${t("inactive")}`}
                  checked={isActive}
                  disabled={isEdit() ? false : true}
                  onChange={(num: boolean) => {
                    setIsActive(num);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="CurrencyForm"
        open={open}
        setOpen={setOpen}
        name={<span>{Currency?.name}</span>}
        title={`${t("this-currency")}`}
        id={id}
        isSaving={isSaving}
      />
    </>
  );
};
